import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { Dollars } from 'barnyard/components';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import DEAItemsTable from './DEAItemsTable';


const DEADollarsAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM Do, YYYY')}
    icon={<BarnyardIcon icon={['fa', 'prescription-bottle-alt']} className='DiscussCard__replyIcon dea' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {' '} spent {' '}
        <strong className='u-colorRed'>
          <Dollars integer={alert.value.total} includeCents={true} />
        </strong>
        {' '} on controlled substances
      </div>
    )}
    content={(
      <DEAItemsTable
        includeExport={true}
        items={alert.value.items}
      />
    )}
    {...other}
  />
);

DEADollarsAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default DEADollarsAlert;
